import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let charts = document.querySelectorAll('.noss_charts.default');
    window.charts = [];
    for (let i = 0; i < charts.length; ++i) {
        window.charts[i] = {
            element: charts[i],
            chart: false
        };
        CreateChart(i, charts[i], 'all', true);
    }
}

function CreateChart(i, selector, segment = 'all', isInit = false) {
    if (window.charts[i].chart) {
        window.charts[i].chart.destroy();
    }
    let allTooltips = selector.querySelectorAll('.tooltip');
    for (let y = 0; y < allTooltips.length; y++) {
        allTooltips[y].remove();
    }

    let encodedDisplayData = selector.dataset.nossChart;
    if (encodedDisplayData) {

        let displayData = JSON.parse(encodedDisplayData);
        let datasets = [];
        //let annos = {};

        let minY = false;
        let maxY = false;
        let minX = false;
        let maxX = false;

        let counter = 0;
        for (const [key, value] of Object.entries(displayData.sets)) {
            let data = [];
            let innerCounter = 0;

            let outerProcess = true;

            if (segment == 'tv' && !key.startsWith('tv-')) {
                outerProcess = false;
            }
            if (segment == 'radio' && !key.startsWith('radio-')) {
                outerProcess = false;
            }
            if (segment == 'online' && !key.startsWith('online-')) {
                outerProcess = false;
            }

            if (outerProcess) {
                value.entries.forEach(function (item, index) {
                    let process = true;
                    if (segment === 'all' && item[5] !== true) {
                        process = false;
                    }

                    if (process) {
                        if (minY === false || parseInt(item[1]) < minY) {
                            minY = parseInt(item[1]);
                        }
                        if (maxY === false || parseInt(item[1]) > maxY) {
                            maxY = parseInt(item[1]);
                        }
                        if (minX === false || parseInt(item[2]) < minX) {
                            minX = parseInt(item[2]);
                        }
                        if (maxX === false || parseInt(item[2]) > maxX) {
                            maxX = parseInt(item[2]);
                        }
                        data.push({
                            x: item[2],
                            y: item[1],
                            r: item[3],
                        })

                        // if (item[5] === true) {
                            let tooltipEl = document.createElement('div');
                            tooltipEl.classList.add('tooltip');
                            tooltipEl.dataset.nossIndex = counter + '-' + innerCounter;
                            tooltipEl.dataset.nossTitle = item[0];
                            tooltipEl.dataset.nossX = item[2];
                            tooltipEl.dataset.nossY = item[1];
                            tooltipEl.dataset.nossOffsetY = item[3];
                            tooltipEl.dataset.nossValue = item[4];
                            tooltipEl.innerHTML = '';
                            if (item[5] === true) {
                                tooltipEl.innerHTML = tooltipEl.innerHTML + '<p><label>' + item[7] + '</label> ' + item[0] + '</p>'
                            }
                            else {
                                if (segment == 'online') {
                                    tooltipEl.innerHTML = tooltipEl.innerHTML + '<p class="nocontract">' + displayData.text.ohnevertrag.online + '</p>'
                                }
                                else {
                                    tooltipEl.innerHTML = tooltipEl.innerHTML + '<p class="nocontract">' + displayData.text.ohnevertrag.all + '</p>'
                                }
                            }
                            tooltipEl.innerHTML = tooltipEl.innerHTML + '<p><label>' + displayData.text.gattung + '</label> ' + item[9] + '</p>'
                            // tooltipEl.innerHTML = tooltipEl.innerHTML + '<p><label>' + displayData.text.durchschnittsalter + '</label> ' + item[2] + '</p>'
                            // tooltipEl.innerHTML = tooltipEl.innerHTML + '<p><label>' + displayData.text.frauenanteil + '</label> ' + item[1] + '</p>'
                            // tooltipEl.innerHTML = tooltipEl.innerHTML + '<p><label>' + displayData.text.reichweite + '</label> ' + item[4] + '</p>'
                            selector.appendChild(tooltipEl);
                        // }

                        // let annoTitle = item[5] === true ? item[0] : displayData.text.ohnevertrag;
                        //
                        // annos['label' + (parseInt(item[6]) + 1)] = {
                        //     type: 'label',
                        //     xValue: item[2],
                        //     yValue: item[1],
                        //     yAdjust: parseInt(item[3]) + 10,
                        //     content: [annoTitle],
                        //     font: {
                        //         size: 10
                        //     }
                        // };

                        innerCounter++;
                    }
                });

                if (data.length > 0) {
                    datasets.push({
                        label: value.name,
                        backgroundColor: value.color,
                        data: data
                    });
                    counter++;
                }
            }
        }

        let chartData = {
            datasets: datasets
        }

        minX = parseInt(minX) - 5;
        maxX = parseInt(maxX) + 5;

        minY = parseInt(minY) - 5;
        if (minY < 0) {
            minY = 0;
        }
        maxY = parseInt(maxY) + 5;
        if (maxY > 100) {
            maxY = 100;
        }

        let chartOptions = {
            responsive: true,
            animation: {
                duration: 0
            },
            scales: {
                x: {
                    min: minX,
                    max: maxX,
                    title: {
                        display: true,
                        color: '#627684',
                        text: displayData.text.durchschnittsalter
                    },
                    ticks: {
                        color: '#627684'
                    }
                },
                y: {
                    min: minY,
                    max: maxY,
                    title: {
                        display: true,
                        color: '#627684',
                        text: displayData.text.frauenanteil2
                    },
                    ticks: {
                        color: '#627684'
                    }
                }
            },
            plugins: {
                legend: {
                    display: false
                },
                zoom: {
                    zoom: {
                        wheel: {
                            enabled: true
                        },
                        pinch: {
                            enabled: true
                        },
                        mode: 'xy',
                    }
                },
                title: {
                    display: true,
                    color: '#354957',
                    padding: {
                        top: 40,
                        bottom: 20
                    },
                    font: {
                        weight: 'normal',
                        size: 18
                    },
                    text: displayData.text.charttitle[segment]
                },
                tooltip: {
                    enabled: false,
                    position: 'nearest',
                    external: externalTooltipHandler
                }
            }
        };


        let chartConfig = {
            type: 'bubble',
            data: chartData,
            options: chartOptions
        };

        window.charts[i].chart = new Chart(selector.querySelector('canvas'),chartConfig);

        if (isInit === true) {
            // map zoom reset button
            let resetBtn = selector.querySelector('.resetZoom');
            if (resetBtn) {
                resetBtn.addEventListener('click', function (event) {
                    event.preventDefault();
                    window.charts[i].chart.resetZoom()
                });
            }

            // filter button
            let filterRadios = selector.querySelectorAll('[name="segment"]');
            for (let y = 0; y < filterRadios.length; y++) {
                filterRadios[y].addEventListener('change', function (event) {
                    event.preventDefault();
                    CreateChart(i, selector, event.target.value);
                });
            }
        }
    }
}

const externalTooltipHandler = (context) => {
    const {chart, tooltip} = context;
    let itemIndex = tooltip.dataPoints[0].dataIndex;
    let setIndex = tooltip.dataPoints[0].datasetIndex;
    let parentNode = chart.canvas.parentNode;
    if (parentNode) {
        let tooltipEl = parentNode.querySelector('[data-noss-index="' + setIndex + '-' + itemIndex + '"]');
        if (tooltipEl) {
            if (tooltip.opacity === 0) {
                let allActiveTooltipEl = parentNode.querySelectorAll('[data-noss-index].show');
                for (let i = 0; i < allActiveTooltipEl.length; ++i) {
                    if (allActiveTooltipEl[i].dataset.nossId !== itemIndex) {
                        allActiveTooltipEl[i].classList.remove('show');
                    }
                }
                return;
            }

            let allActiveTooltipEl = parentNode.querySelectorAll('[data-noss-index].show');
            for (let i = 0; i < allActiveTooltipEl.length; ++i) {
                if (allActiveTooltipEl[i].dataset.nossId !== itemIndex) {
                    allActiveTooltipEl[i].classList.remove('show');
                }
            }

            const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;
            tooltipEl.style.left = positionX + tooltip.caretX + 'px';
            tooltipEl.style.top = positionY + tooltip.caretY + parseInt(tooltipEl.dataset.nossOffsetY) + 'px';

            tooltipEl.classList.add('show');
        }
    }
};